<template>
  <div class="dashboard">
	<div id="ajaxLoadingSpinnerOverlay" v-if="!states.showMain">
		<div class="ajaxLoadingSpinnerOverlay-container">
			<div class="square first pulse infinite animated"></div>
			<div class="square second pulse infinite animated"></div>
			<div class="square third pulse infinite animated"></div>
		</div>
	</div>
  <div class="text">
	<h2 class="t-text-bolder">{{msg}}</h2>
	<div v-show="states.verifPages">
	<p id="intro">Na tejto stránke môžete bezplatne získať svoj ID alebo PID kód, ktorý vyžadujeme pri vybavovaní požiadaviek na internete alebo pri telefonickom kontakte. Bude potrebné zadať niektoré vaše zmluvné osobné údaje. Zadané dáta sú v bezpečí, komunikácia na tejto stránke je zabezpečená.</p>
	<p>Na telefónne číslo, ktoré ste pri uzatváraní zmluvy alebo neskoršej aktualizácii zmluvy uviedli ako primárny kontakt, odošleme overovací SMS kód.</p>
	<br/>
	<div v-show="states.start">
		<p class="mab-0"><strong>Kontaktné telefónne číslo</strong></p>
	<div class="form-group" style="max-width:290px;">
	<input type="text" class="form-control" placeholder="09________" v-model="msisdn" id="msisdn" ref="msisdn">
	<p>&nbsp;</p>
	</div>
	<p class="mab-0"><strong>Číslo adresáta z faktúry</strong>
	<img style="width:2.4rem;margin-left:1rem;" class="masterTooltip" src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAIAAAACACAYAAADDPmHLAAAFl0lEQVR4nO2dS2icVRiGH20KotiSFtGFVomCUvCCm4ILRWlQES2Isd4Qg7TRVhF1UTFScONOULLQIt2UilJE6c2NolAllnqpbVVQVDSgtF5qvKS1jaYu/gmIEOd8/5xz3n/mfA+8my7mfN/7vmQ6M/8/A47jOI7jOI7jOI7jOI7jODE4BxgEhoDbXEEaApYDZ9fwuxEsAtYDXwInXB3pC2AU6DclIOQe4DB643pNPwF3hseQn5OAZ9Eb1et6OjSQ3DyF3pxS9GRgJtkYBGbQG1OKZoCrg5LJwMnAZ+hNKU37qZ525VyP3oxSNRiQT3I2ojeiVG0IyCc5n6I3olQdCMgnOX+gN6JU/R6QT3LUJoTqb2AvsAl4AlgN3NHS6ta/bQI+prte0chRG/B/mga2AyuxvZW6iOo9+R2tx1Dv4QUw6gjVu5IxPkxZAowBRxuwlxcgQNuA8xLsOQDsbMB+XoA5NAUMJ94VYBXN+msgR23ACeB74NLUi/6Ly4GDCfbwAtTQ16T5k9+OAeBb46xegMg6BFyQfsU5uZDqc3ovgEDTwBUZ9mvHVcBfeAGya12O5QJZjxcgqz4C5uVYLpA+4BO8ANlU90//QuB+qvcKJoDjLU0AW4ERYEHNx76mxh5egBp6s8aM84HHgV8DHn+S6umlr8Y570TYzwvQRtca5zsDGK9xzi5gsfGsmxLu7QUAvqO6BC2Ufjp7bt5H9bQRSh/wQ0Y/iivAM8bZdkQ481Xjmc8l2NsL0NKNhrlujXjuCsO5Qxn9KK4Als/090c89wPDuWdl9KOoAhwyzHRZgvOXGs7/JYMfxRVg3DDTwwnOX2s4//0MfhRXgNcNM21IcP6Y4fw3MvhRXAF2E35/fZ3X/e202eDJaxl9kZNrUbU2GjzZnnEuOepgcmnU4MnujHPJUQeTS5a7cX/MOJccdTA5dJDwD4eWZJ5NjjqcHHrM4Mdw5tnkqMNJrc+BUwx+5L53QI46oJT6DbjE4MW55L8+UI46pFSaorrg08LzgjnlqINKoSNUl3hZuBjN1cFy1GHF1lHsX70yn+oTQ8W8ctSBxdSfwHU1PMh9EYgXIIGOATfU2H9UPLccdXAxdBzbVT+zPNqA2eWoDehU08DNNfZ+sAGzewE61Axwe42dR2jO9wjJURvQiSxv8c4yTHPC9wJ0oG01dr2L6tvG1LN7ATrUz8CZxj1Xor0N3AsQUWuMOy6neqWgntsLEEFfYbvx83zyXubtBUisBwy79QF7GjCzFyCSprDd//9QA2b2AkTUFsNep5L32j4vQAbdbdhrVQPm9QJE1oBhr7cbMK8XIKImDTudRvO/JdwLYNSHhp2ubMC8XoDI2mnY6b4GzOsFiCzLK4Bu+hFMOWoDQvWyYacXGjCvFyCyLAV4qQHzegEia5zw7xfIeXevF8DlBXB5AVw1JUdtQOmSozagdMlRG1C65KgNKF1y1AaULjlqA0qXHLUBpUuO2oBQvQvcEqj3GjCvFyCyLB8GvdKAeb0AkeUFSITaAC+AGLUBXgAxagO8AGLUBngBxKgN8AKIURvgBRCjNsALIEZtgBdATFO/OqUEHQvIJzkT6I0oVd+0jyc9W9EbUaqsv2yehBH0RpSqewPySc4Cqnvv1WaUpsPA6QH5ZGEdekNK0yNByWSiD9iF3pRS9BYwLyiZjCwG9qE3p9e1F+gPzCQ7C6n+Z6o2qVe1Bdv3HMpYge5HlHpRe6j3czZylgJrgTHgRaq3Y2NL+QpkMtFOm1uerQEuMrteGMvQlGCydbbTAHKXwMNvILlK4OE3mNQl8PC7gFQl8PC7iNgl8PC7kFgl8PC7mE5L4OH3AHVL4OH3ENYSePg9SGgJPPwepl0JPPwCmKsEHn5B/LcEHn6BzJbAwy+YZXj4juM4juM4Tmn8A7ecfIuQ0nQNAAAAAElFTkSuQmCC" title="Číslo adresáta nájdete aj v pravom hornom rohu hlavičky svojej faktúry za služby Telekom.">					
	</p>
	<div class="form-group" style="max-width:290px;">
	<input type="text" class="form-control" id="bpn" v-model="bpn">
	<p>&nbsp;</p>
	<div v-html="states.msisdnError" style="color:#e20074;text-align:center;font-size:1.7rem;" v-on:click="states.msisdnError = '&nbsp;'"></div>
	</div>
	<div class="form-group" style="max-width:290px;">
		<input value="ODOSLAŤ" v-on:click="startVerif()" class="btn btn-magenta" title="" type="button" style="min-width:100%" id="msisdnSubmit">
	<p>&nbsp;</p>
	</div>
	</div>
	<div v-show="states.verify">
		<p><strong>Zadajte overovací kód doručený v SMS správe na tel. číslo 0{{ validateMsisdn(msisdn) }}.</strong></p>
			<div class="form-group" style="max-width:290px;">
			<input class="form-control" id="code" v-model="code" title="" type="text" style="min-width:100%;" ref="code">
			<p>&nbsp;</p>
			<div v-html="states.msisdnError" style="color:#e20074;text-align:center;font-size:1.7rem;" v-on:click="states.msisdnError = '&nbsp;'"></div>
			</div>
			<div class="form-group" style="max-width:290px;">
				<input value="POTVRDIŤ" v-on:click="mainAuth()" class="btn btn-magenta" title="" type="button" style="min-width:100%" id="codeSubmit">
				<p></p>
				<p class="text-center"> <a class="link" v-on:click="states.verify=!states.verify;states.start=!states.start;states.msisdnError='&nbsp;'" style="cursor:pointer">Vrátiť späť</a></p>
			<p>&nbsp;</p>
		</div>
	</div>
	</div>
	<Actions  v-if="states.mainPage" :states="states" :verifData="verifData" :bpn="bpn" :msisdn="validMsisdn" :scenarioType="scenarioType" />
	</div>
</div>
</template>
<script>
import Actions from './actions'
export default {
  name: 'PinPid',
  components: {
	  Actions
  },
  data() {
    return {
    states: {
      showMain: true, msisdnError: "&nbsp;", start: true, verify: false, verifPages: true, mainPage: false, token: ''
	},
	msisdn: '',
	validMsisdn: '',
	bpn: '',
	code: '',
	verifData: {},
	scenarioType: "residential"
    }
  },
  mounted: function() {
	  $('.masterTooltip').tooltip()
	  this.keyEnterTarget('msisdn', 'msisdnSubmit')
	  this.keyEnterTarget('bpn', 'msisdnSubmit')
	  this.keyEnterTarget('code', 'codeSubmit')
	  $(this.$refs.msisdn).focus()
  },
  created: function() {
	  var that = this
  },
  methods: {
	  startVerif: function() {
		var msisdn = this.validateMsisdn(this.msisdn)
		this.validMsisdn = msisdn
		var that = this
		if (msisdn) {
			if (this.bpn.replace(/ /g, '').length > 7) {
			that.states.start = false
			that.states.verify = true
			that.code = ''
			that.$nextTick(function(){
			    $(that.$refs.code).focus()
				$('.masterTooltip').tooltip()
			})			
			this.$http.post(this.$store.state.getOtpCodeSrc + "/" + msisdn, { msisdn: msisdn, system_id: "3"})
			.then(function (resp) {
				that.states.msisdnError = '&nbsp;'
				if ((resp.data.otp_code) && (window.location.hostname !== 'www.telekom.sk')) {
					that.code = resp.data.otp_code;
				} else {
					that.code = ''
				}
			})
			.catch(function(e){
				that.states.msisdnError = "CHYBA NAČÍTANIA"
			})
			} else {
			that.states.msisdnError = 'Číslo adresáta nemá platný formát.'
			}
		} else {
			that.states.msisdnError = 'Zadané tel. číslo je neplatné.'
		}	
	  },
	  mainAuth: function() {
		  var that = this
		  that.states.showMain = false
		  if ((this.code.toString().replace(/ /g, '').length > 3) && (!_.isNaN(this.code.toString().replace(/ /g, '')))) {
			this.$http.put(this.$store.state.getOtpCodeSrc + "/" + that.validMsisdn, { msisdn: that.validMsisdn, system_id: "3", otp_code: that.code})
			.then(function (resp) { 
				if (resp.data.token !== undefined) {
					that.states.token = resp.data.token
					that.$http.get(that.$store.state.validateCustSrc + "/" + that.bpn.replace(/ /g, '') + "/" + resp.data.token)
					.then(function(resp){
						if (resp.data.scenario === 'none') {
							that.states.msisdnError = 'Neznáma chyba. Nieje možné pokračovať.'			
						} else {
							if ((resp.data.scenario === 'business') || (resp.data.scenario === 'denied')) {
								that.scenarioType = 'business'
							} else {
								that.scenarioType = 'residential'
							}
							that.states.verifPages = false
							that.states.mainPage = true
							that.verifData = resp.data
							that.bpn = that.bpn.replace(/ /g, '')
							that.$nextTick(function(){
								$('.masterTooltip').tooltip()
							})
						}				
					})
					.catch(function(err){
					that.states.msisdnError = 'CHYBA SPRACOVANIA.'			
						if (err.response.status === 403) {
							that.states.msisdnError = 'Prihlásenie exspirovalo.'			
						}
						if ((err.response.status === 404) && (err.response.data.message == 'not-found')) {
							that.states.verifPages = false
							that.states.mainPage = true
							that.verifData = err.response.data
							that.bpn = that.bpn.replace(/ /g, '')					
						}
					})
					.finally(function(f){
						that.states.showMain = true
					});
				} else {
					that.states.msisdnError = 'CHYBA SPRACOVANIA.'			
				}
			})
			.catch(function(e){
				that.states.showMain = true
				if (e.response.status === 404) {
				that.states.msisdnError = 'Neplatný kód.'	
				} else {
				that.states.msisdnError = 'CHYBA SPRACOVANIA.'			
				}
			})
		  } else {
			that.states.msisdnError = 'Neplatný kód.'
			that.states.showMain = true
		  }
    },
	validateMsisdn: function(cnr) {
	var tMsisdn = String(cnr).replace(/(\r\n|\n|\r| )/gm, "")
		, rtrn = false
		, tRtrn;
	if (tMsisdn.length >= 9) {
		tRtrn = tMsisdn.substring(tMsisdn.length - 9, tMsisdn.length);
	}
	else if (tMsisdn.length == 9) {
		tRtrn = tMsisdn;
	}
	if (($.isNumeric(tRtrn)) && (tRtrn.indexOf(0) != '0')) {
		if (tRtrn.substr(0,1) == 9) {
		rtrn = tRtrn;
		}
	}
	return rtrn;
	},
	keyEnterTarget: function(inid, target) {
		$('#' + inid).keypress(function (e) {
			if (e.which == 13) {
				$('#' + target).click();
			}
		});
	}
  },
  computed: {
	  msg: function() {
		  var res = 'Váš ID / PID kód'
		  if (this.states.verifPages === true) {
			  res = 'Váš ID / PID kód'
		  } else {
			  if (this.scenarioType == 'business') {
				  res = 'Váš PID kód'
			  } else {
				  res = 'Váš ID kód'
			  }
		  }
		  return res
	  }
  }
}
</script>

<style scoped>
.text {
  padding: 0 4px;
}
.t-text-bolder {
	font-weight: 700;
	font-size: 26px;
}
h2 {
  font-weight: 700;
  margin-bottom: 18px;	
}
.mab-0 {
	margin-bottom: 4px;
}
</style>
